import { createUseStyles } from 'react-jss';
import { colors } from '@insurancemenu/imenu-components-lib';

const styles = {
  groupName: {
    font: {
      size: '2.4rem',
      lineHeight: '3.2rem',
      weight: 700,
    },
    margin: {
      bottom: '2.4rem',
    },
  },
  contactFieldBox: {
    '&:not(:last-child)': {
      paddingBottom: '1.6rem',
    },
  },
  fieldName: {
    textTransform: 'uppercase',
    color: colors.neutral[500],
    margin: [0],
    font: {
      size: '1.4rem',
      lineHeight: '2rem',
      weight: 700,
    },
  },
  fieldValue: {
    paddingTop: '0.4rem',
    margin: [0],
    wordBreak: 'break-word',
    font: {
      size: '1.8rem',
      lineHeight: '2.8rem',
      weight: 400,
    },
  },
  contentWrapper: {
    marginBottom: '3.8rem',
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
